import Account from '@/lib/account'
import * as Constants from '@/lib/constants'
import * as Filters from '@/lib/filters'
import Thumbnailer from '@/lib/mapbox/thumbnailer'
import PagingOptions from '@/lib/paging-options'
import Planting from '@/lib/planting'
import UserInfo from '@/lib/user-info'

export default {
  mounted: function() {
    this.refreshList()
    this.onResize()
  },

  data() {
    return {
      fieldForDelete: undefined,
      isMobile: false,
      pagingType: PagingOptions.FIELD_PAGING_TYPE,
    }
  },

  computed: {
    fields() {
      return this.$store.getters.fields
    },
    nowListingFields() {
      return this.$store.getters.nowListingFields
    },
    paginationInfo() {
      return this.$store.getters.paginationInfos.fields
    },
  },

  methods: {
    onResize() {
      if (window.innerWidth < Constants.RESPONSIVE_BREAKPOINT_FIELD_LIST) this.isMobile = true
      else this.isMobile = false
    },
    showDetail(field) {
      this.$store.dispatch('getAllFields')
      this.$store.dispatch('showFieldDetail2', field)
    },
    refreshList() {
      if (!this.nowListingFields) {
        this.initFields()
      }
    },

    initFields() {
      this.$store.dispatch('initFields2')
    },
    // initPlantings() {
    //   this.$store.dispatch('currentPlantings')
    // },

    getAccount(field) {
      return Account.getByField(field)
    },
    fieldCreatedDate(field) {
      const createDate = Filters.aidToYearMonthDay(field.createdDateTime)
      return this.$tt('DocFormFieldRegisteredDateFormatBase', { createDate: createDate })
    },

    calculateStaticThumbnailUrl(field) {
      const isMyField = this.isMyField(field)

      const th = new Thumbnailer()
      // th.isRetina = true

      return th.getFieldThumbnailUrlFromGoogle(field, Constants.DEFAULT_MAP_SIZE, isMyField)
    },
    isMyField(field) {
      return UserInfo.getUsername() === field.username
    },
    updatePaging(pagingOptions) {
      this.$store.dispatch('updatePagingOfFieldList', { pagingOptions })
    },

    listCurrentPlantings(field) {
      return Planting.listCurrentForField(field)
    },
  },
}
